import { isEmpty } from "ramda";
import { FilterQueryProps } from "./BulkUpdate";

export const bulkUpdateLimit = parseInt(process.env.BULK_UPDATE_LIMIT || "10");

export function showBulkUpdateButtonTooltip<T>(
  storeObjects: number,
  filterQuery?: FilterQueryProps<T>["filterQuery"]
) {
  if (isEmpty(filterQuery) || isEmpty(filterQuery && filterQuery.values)) {
    return `Filter data to use this feature`;
  } else {
    if (storeObjects === 0) {
      return "You have no item to update";
    } else if (storeObjects > bulkUpdateLimit) {
      return `You can update max ${bulkUpdateLimit} items while you have ${storeObjects} items in fitered data`;
    } else {
      return `Apply bulk Update for ${storeObjects} items below`;
    }
  }
}
